<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div class="preview-container text-center my-3">
            <label style="color: #405950; font-size: 16px" class="mt-5">{{
              $t("MESSAGES.Main product image")
            }}</label>
            <br />
            <img
              :src="data.image.path"
              alt="Product Image"
              v-if="data.image.path"
              class="mx-5 my-3 img-thumbnail"
            />
          </div>

          <div>
            <div>
              <label style="color: #405950; font-size: 16px" class="mt-5">{{
                $t("MESSAGES.Product images")
              }}</label>
            </div>
            <img
              v-for="img in AddimgUrls"
              :src="img"
              style="width: 200px; height: 150px; cursor: pointer"
              class="mx-5 my-3 img-thumbnail"
              @click="showImageModal(img)"
            />
          </div>

          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codename')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codenameEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProd')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProdEn')"
            v-model.trim="data.descProdEn"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Product category')"
            :value="data.product_category_id?.name"
            disabled
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            v-model.trim="data.price"
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.quantatyy')"
            v-model.trim="data.quantity"
            disabled
          />
          <!-- End:: Name Input -->

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('TABLES.Workplaces.date')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <template>
      <!-- Start:: Image Modal -->
      <image-modal
        v-if="dialogImage"
        :type="selectedItemType"
        :modalIsOpen="dialogImage"
        :modalImage="selectedItemImage"
        @toggleModal="dialogImage = !dialogImage"
      />
    </template>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowProduct",

  data() {
    return {
      dialogImage: false,
      selectedItemImage: null,
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      AddimgUrls: [],

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        price: null,
        product_category_id: null,
        quantity: null,
        created_at: null,
        active: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemImage = item;
      this.selectedItemType = item.endsWith("mp4") ? "video" : "image";
    },
    // start show data
    async showProduct() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `products/${this.$route.params.id}`,
        });
        this.data.image.path = res.data.data.Product.main_image;
        this.data.name = res.data.data.Product.name_ar;
        this.data.nameEn = res.data.data.Product.name_en;
        this.data.descProd = res.data.data.Product.description_ar;
        this.data.descProdEn = res.data.data.Product.description_en;
        this.data.price = res.data.data.Product.price;
        this.data.quantity = res.data.data.Product.quantity;
        this.data.created_at = res.data.data.Product.created_at;
        this.data.active = res.data.data.Product.is_active;
        this.data.product_category_id =
          res.data.data.Product.product_category_id;
        this.AddimgUrls =
          res.data.data.Product.gallery &&
          res.data.data.Product.gallery.map((item) => item.url);
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.showProduct();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
}
</style>
